import { useState, useEffect, useCallback } from 'react';
import { axiosInstance } from '../../../../api/axios';
import APIEndpoints from '../../../api/APIEndpoints';
import { HttpSuccessCodes } from '../../../errorhandling/HttpErrorCodes';
import { useSelector } from 'react-redux';
import { maskedSSN } from 'src/common/masking';
import debounce from 'lodash.debounce';

const useDocumentType = ({
  docType,
  resetDocType,
  setResetDocType,
  physicianType,
  selectedDocTypeData,
  setSelectedDocTypeData,
  loadLocation,
  setLoadLocation,
  setSelectedLocationData,
  defaultLocationloader,
  setDefaultLocationloader,
  defaultValueskeletonLoader,
  setDefaultValueSkeletonLoader,
  displayFirstRecord = false,
}) => {
  const [openBlobModal, setOpenBlobModal] = useState(false);
  const [searchString, setSearchString] = useState('');
  const [docTypeData, setDocTypeData] = useState([]);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showMoreData, setShowMoreData] = useState(false);
  const [isServerError, setIsServerError] = useState(false);
  //const [defaultValueskeletonLoader, setDefaultValueSkeletonLoader] =
  //useState(true);

  const getBlobData = async (checkDefaultValue = false) => {
    try {
      const BlobListResponse = await axiosInstance.get(
        APIEndpoints.getBLOBListResources() + 'pagesize/5000',
      );
      if (BlobListResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        if (BlobListResponse?.data?.Response?.BlockOfBusiness) {
          if (checkDefaultValue) {
            //const defaultData =
            //BlobListResponse?.data?.Response?.BlockOfBusiness.filter(
            //(item, index) => index === 0,
            //);
            const defaultData =
              BlobListResponse?.data?.Response?.BlockOfBusiness;

            if (
              defaultData.length === 1 ||
              (defaultData.length > 1 && displayFirstRecord)
            ) {
              const tempSelectedData = { ...defaultData[0], isChecked: true };
              setSelectedDocTypeData(tempSelectedData);
              setDocTypeData(defaultData);
              setResetDocType(false);
              setSkeletonLoader(false);
              setIsServerError(false);
            }
            setDefaultValueSkeletonLoader(false);
          } else {
            setDocTypeData(BlobListResponse?.data?.Response?.BlockOfBusiness);
            setSkeletonLoader(false);
            setResetDocType(false);
            setIsServerError(false);
          }
        }
      }
    } catch (error) {
      console.log(error);
      setIsServerError(true);
      return { isError: true, errorObj: error };
    }
  };

  const getEmployerData = async (checkDefaultValue = false) => {
    try {
      const EmployerListResponse = await axiosInstance.get(
        APIEndpoints.getEmployerListResources() + 'pagesize/5000',
      );
      if (
        EmployerListResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200
      ) {
        if (EmployerListResponse?.data?.Response?.Client) {
          if (checkDefaultValue) {
            //const defaultData =
            //EmployerListResponse?.data?.Response?.Client.filter(
            //(item, index) => index === 0,
            //);
            const defaultData = EmployerListResponse?.data?.Response?.Client;
            if (
              defaultData.length === 1 ||
              (defaultData.length > 1 && displayFirstRecord)
            ) {
              const tempSelectedData = { ...defaultData[0], isChecked: true };
              setSelectedDocTypeData(tempSelectedData);
              setDocTypeData(defaultData);
              setResetDocType(false);
              setSkeletonLoader(false);
              setIsServerError(false);
              setDefaultLocationloader(true);
            }
            setDefaultValueSkeletonLoader(false);
          } else {
            setDocTypeData(EmployerListResponse?.data?.Response?.Client);
            setSkeletonLoader(false);
            setIsServerError(false);
            setResetDocType(false);
          }
        }
      }
    } catch (error) {
      console.log(error);
      setIsServerError(true);
      return { isError: true, errorObj: error };
    }
  };

  const getLocationData = async (checkDefaultValue = false) => {
    try {
      const EmployerListResponse = await axiosInstance.get(
        APIEndpoints.getLocationListResources() +
          'pagesize/5000/clientoid/' +
          selectedDocTypeData.oid,
      );
      if (
        EmployerListResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200
      ) {
        if (EmployerListResponse?.data?.Response?.Location) {
          if (checkDefaultValue) {
            //const defaultData =
            //EmployerListResponse?.data?.Response?.Location.filter(
            //(item, index) => index === 0,
            //);
            const defaultData = EmployerListResponse?.data?.Response?.Location;
            if (defaultData.length === 1) {
              const tempSelectedData = { ...defaultData[0], isChecked: true };
              setSelectedLocationData(tempSelectedData);
              setResetDocType(false);
              setSkeletonLoader(false);
              setIsServerError(false);
            }
            setDefaultValueSkeletonLoader(false);
          } else {
            setDocTypeData(EmployerListResponse?.data?.Response?.Location);
            setSkeletonLoader(false);
            setResetDocType(false);
            setIsServerError(false);
          }
        }
      }
    } catch (error) {
      console.log(error);
      setIsServerError(true);
      setDefaultValueSkeletonLoader(false);
      return { isError: true, errorObj: error };
    }
  };

  const getPhysicianData = async () => {
    const configURL =
      physicianType === 'D'
        ? APIEndpoints.getDoctorsListResources()
        : physicianType === 'F'
        ? APIEndpoints.getFacilityListResources()
        : '';

    const URLString = `${configURL}searchkey/${searchString}/pagesize/10/pagenumber/${currentPage}`;

    if (searchString && searchString.length > 2) {
      try {
        const PhysicianListResponse = await axiosInstance.get(URLString);
        if (
          PhysicianListResponse.status ===
          HttpSuccessCodes.HTTP_SUCCESS_CODE_200
        ) {
          const { TotalRecords } =
            PhysicianListResponse.data.Response.Pagination;
          const responseKey =
            physicianType === 'D' ? 'PhysicianViewDetails' : 'FacilityDetails';
          if (PhysicianListResponse?.data?.Response[responseKey]) {
            const updatedData =
              physicianType === 'D'
                ? [
                    ...docTypeData,
                    ...PhysicianListResponse.data.Response[responseKey],
                  ]
                : [
                    ...docTypeData,
                    ...PhysicianListResponse.data.Response[responseKey],
                  ];

            //console.log('updatedData--@', updatedData);
            setDocTypeData(updatedData);
            setSkeletonLoader(false);
            setResetDocType(false);
            setIsServerError(false);
            if (TotalRecords > updatedData.length) {
              setShowMoreData(true);
            } else {
              //console.log('setShowMoreData...to false');
              //console.log('setShowMoreData...to false', TotalRecords);
              //console.log('setShowMoreData...to false', updatedData.length);
              setShowMoreData(false);
            }
          }
        }
      } catch (error) {
        console.log(error);
        setSkeletonLoader(false);
        setIsServerError(true);
        return { isError: true, errorObj: error };
      }
    } else {
      setSkeletonLoader(false);
      setResetDocType(false);
      setDocTypeData([]);
    }
  };

  const { adminConfigData = {} } = useSelector((state) => state.user || {});

  const { Suppress_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};

  const getMaskedSsn = (ssn) => {
    return maskedSSN(
      Suppress_Setting?.SSN ? Suppress_Setting?.SSN : false,
      ssn,
    );
  };

  const getMemberIdKey = () => {
    if (adminConfigData?.attributeNameConfiguration?.length > 0) {
      const configuredData =
        adminConfigData?.attributeNameConfiguration?.filter((item) => {
          return item?.memberID === true;
        });
      if (configuredData[0]?.memberID && configuredData[0]?.attributeKey) {
        const key = configuredData[0]?.attributeKey;
        const capitilizedKey = key[0].toUpperCase() + key.slice(1);
        return capitilizedKey;
      } else {
        return '';
      }
    } else {
      return '';
    }
  };

  const getMemberDependentData = async () => {
    try {
      let strSearchText = '';
      if (memDepSearchDbouce?.length > 2) {
        strSearchText = `SearchKey/${memDepSearchDbouce}/`;
      }

      const SearchMemberListResponse = await axiosInstance.get(
        APIEndpoints.getAllMemberListResources() +
          strSearchText +
          'PageSize/' +
          50 +
          '/PageNumber/' +
          1,
      );

      const SearchMemberListDataResp = await SearchMemberListResponse.data;
      if (SearchMemberListDataResp?.Response?.MemberOrDependent?.length > 0) {
        const DATA_WITH_CONFIGURED_MEMBER_ID = [];
        const MEMBER_ID_CONFIGURED_KEY = getMemberIdKey();
        SearchMemberListDataResp?.Response?.MemberOrDependent?.map((item) => {
          DATA_WITH_CONFIGURED_MEMBER_ID.push({
            ...item,
            memberID: item[MEMBER_ID_CONFIGURED_KEY] || item?.CertificateNumber,
          });
        });
        setDocTypeData(DATA_WITH_CONFIGURED_MEMBER_ID);
      } else {
        setDocTypeData([]);
      }
    } catch (error) {
      console.log('error', error);
      setDocTypeData([]);
    } finally {
      setSkeletonLoader(false);
      setResetDocType(false);
    }
  };

  const getBrokerData = async (checkDefaultValue = false) => {
    try {
      const BrokerListResponse = await axiosInstance.get(
        APIEndpoints.getAllBrokers(),
      );
      if (
        BrokerListResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200
      ) {
        if (BrokerListResponse?.data?.Response?.BrokerDemographic) {
          if (checkDefaultValue) {
            //const defaultData =
            //BrokerListResponse?.data?.Response?.BrokerDemographic.filter(
            //(item, index) => index === 0,
            //);
            const defaultData =
              BrokerListResponse?.data?.Response?.BrokerDemographic;
            if (
              defaultData.length === 1 ||
              (defaultData.length > 1 && displayFirstRecord)
            ) {
              setDocTypeData(defaultData);
              setResetDocType(false);
              setSkeletonLoader(false);
              const tempSelectedData = { ...defaultData[0], isChecked: true };
              setSelectedDocTypeData(tempSelectedData);
            }
            setDefaultValueSkeletonLoader(false);
          } else {
            setDocTypeData(
              BrokerListResponse?.data?.Response?.BrokerDemographic,
            );
            setSkeletonLoader(false);
            setResetDocType(false);
          }
        }
      }
    } catch (error) {
      console.log(error);
      setIsServerError(true);
      return { isError: true, errorObj: error };
    }
  };

  const selectChangeHandler = () => {
    const tempSelectedData = docTypeData.filter(
      (item) => item?.isChecked === true,
    )[0];
    !loadLocation
      ? setSelectedDocTypeData(tempSelectedData)
      : setSelectedLocationData(tempSelectedData);
    setOpenBlobModal(false);
    setResetDocType(false);
    setSearchString('');
    setLoadLocation(false);
    if (!loadLocation && docType.value === 'Location') {
      setDefaultLocationloader(true);
    }
  };

  const deleteSelectedDocype = () => {
    setSelectedDocTypeData();
    setSelectedLocationData();
    setLoadLocation(false);
    //setDefaultLocationloader(false);
  };

  const deleteLocationHandler = () => {
    setSelectedLocationData();
  };

  const searchStringHandler = (value) => {
    setSearchString(value);
    if (
      docType.value === 'PHYSICIAN' ||
      docType.value === 'CONNECTOR' ||
      docType.value === 'FACILITY'
    ) {
      setDocTypeData([]);
      setCurrentPage(1);
    }
  };

  useEffect(() => {
    if (openBlobModal) {
      if (docType.value === 'Block of Business') {
        setSkeletonLoader(true);
        getBlobData();
      } else if (docType.value === 'CLIENT') {
        setSkeletonLoader(true);
        getEmployerData();
      } else if (docType.value === 'BROKER') {
        setSkeletonLoader(true);
        getBrokerData();
      } else if (docType.value === 'Location') {
        if (loadLocation) {
          setSkeletonLoader(true);
          getLocationData();
        } else {
          setSkeletonLoader(true);
          getEmployerData();
        }
      }
    }
  }, [openBlobModal]);

  useEffect(() => {
    if (docType.value === 'Block of Business') {
      setDefaultValueSkeletonLoader(true);
      getBlobData(true);
    } else if (docType.value === 'CLIENT') {
      setDefaultValueSkeletonLoader(true);
      getEmployerData(true);
    } else if (docType.value === 'BROKER') {
      setDefaultValueSkeletonLoader(true);
      getBrokerData(true);
    } else if (docType.value === 'Location') {
      setDefaultValueSkeletonLoader(true);
      if (defaultLocationloader && selectedDocTypeData) {
        setDefaultValueSkeletonLoader(true);
        getLocationData(true);
      } else {
        setDefaultValueSkeletonLoader(true);
        getEmployerData(true);
      }
    }
  }, [docType, defaultLocationloader]);

  useEffect(() => {
    if (
      docType.value === 'PHYSICIAN' ||
      docType.value === 'CONNECTOR' ||
      docType.value === 'FACILITY'
    ) {
      if (searchString && searchString.length > 2) {
        setSkeletonLoader(true);
        getPhysicianData();
      } else {
        setDocTypeData([]);
      }
    }
  }, [searchString, currentPage]);

  const [memDepSearchDbouce, setMemDepSearchDbouce] = useState('');

  const debouncedCall = useCallback(
    debounce((currentVal) => setMemDepSearchDbouce(currentVal), 800),
    [],
  );

  useEffect(() => {
    if (searchString?.length === 0 || searchString?.length > 2)
      debouncedCall(searchString);
  }, [searchString]);

  useEffect(() => {
    if (docType.value === 'EMPLOYEE' || docType.value === 'DEPENDENT') {
      if (memDepSearchDbouce && memDepSearchDbouce.length > 2) {
        setSkeletonLoader(true);
        getMemberDependentData();
      } else {
        setDocTypeData([]);
      }
    }
  }, [memDepSearchDbouce]);

  useEffect(() => {
    if (resetDocType) {
      setSelectedDocTypeData();
      setDocTypeData([]);
    }
  }, [resetDocType]);

  return {
    openBlobModal,
    skeletonLoader,
    searchString,
    docTypeData,
    selectedDocTypeData,
    showMoreData,
    isServerError,
    setOpenBlobModal,
    setSearchString,
    setDocTypeData,
    selectChangeHandler,
    deleteSelectedDocype,
    searchStringHandler,
    setCurrentPage,
    setShowMoreData,
    deleteLocationHandler,
    defaultValueskeletonLoader,
    getMaskedSsn,
  };
};

export default useDocumentType;
